export const environment = {
  envName: "test",
  production: false,
  apiUrl: "/api/",
  ssoUrl: "https://login.microsoftonline.com/dbsw.onmicrosoft.com/oauth2/v2.0",
  clientId: "51213f98-4585-4f54-a09b-eae7c44299a7",
  redirectUrl: "https://test.artes-go.dk/api/login/oauth2",
  openIdConfiguration: ""
};
